import React from 'react';
import { Route } from 'react-router-dom';
import Guests from './guests';

export default <Route path="/homepage/meus-convidados" component={Guests} />;
